import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE } from './api/client';
import './AdminJobList.css';

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const AdminJobList = ({ onSelectJob }) => {
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchJobs = async () => {
            try {
                const response = await fetch(`${API_BASE}/api/job/admin/jobs`, { headers: authHeaders() });
                if (!response.ok) throw new Error("Failed to fetch jobs");
                const data = await response.json();
                setJobs(data);
            } catch (err) {
                console.error("Error fetching jobs:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchJobs();
    }, []);

    const toggleJobStatus = async (jobId) => {
        try {
            const response = await fetch(`${API_BASE}/api/job/admin/jobs/${jobId}/toggle-status`, {
                method: "PATCH",
                headers: authHeaders(),
            });
            if (!response.ok) throw new Error("Failed to toggle job status");
            const data = await response.json();
            console.log(data.message);

            // Update job status locally
            setJobs((prevJobs) =>
                prevJobs.map((job) =>
                    job._id === jobId ? { ...job, status: data.status } : job
                )
            );
        } catch (err) {
            console.error("Error toggling job status:", err);
            alert("Failed to toggle job status");
        }
    };

    const onDeleteJob = async (jobId) => {
        if (!window.confirm("Are you sure you want to delete this job?")) return;

        try {
            const response = await fetch(`${API_BASE}/api/job/admin/jobs/${jobId}`, {
                method: "DELETE",
                headers: authHeaders(),
            });
            if (!response.ok) throw new Error("Failed to delete job");
            console.log("Job deleted successfully");

            // Remove the job from the local state
            setJobs((prevJobs) => prevJobs.filter((job) => job._id !== jobId));
        } catch (err) {
            console.error("Error deleting job:", err);
            alert("Failed to delete job");
        }
    };

    if (loading) return <div>Loading jobs...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="admin-job-list">
            <h2>Job Listings</h2>
            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Job Title</th>
                            <th>Applications</th>
                            <th>Status</th>
                            <th>Created At</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {jobs.map((job) => {
                            const jobTitle = job.fields.find((field) => field.label === "Job Title")?.value;
                            return (
                                <tr key={job._id} onClick={() => onSelectJob(job._id)}>
                                    <td>{jobTitle}</td>
                                    <td>{job.applicationCount}</td>
                                    <td>{job.status || "Active"}</td>
                                    <td>{new Date(job.createdAt).toLocaleDateString()}</td>
                                    <td>
                                        <button
                                            className="change-status-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                toggleJobStatus(job._id);
                                            }}
                                        >
                                            <i className="fas fa-exchange-alt" style={{ marginRight: '8px' }}></i>Change Status
                                        </button>
                                        <button className="edit-btn" onClick={() => navigate(`/edit-job/${job._id}`, { state: { jobId: job._id } })}>
                                            <i className="fas fa-edit" style={{ marginRight: '8px' }}></i>Edit
                                        </button>
                                        <button 
                                            className="delete-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onDeleteJob(job._id);
                                            }}
                                        >
                                            <i className="fas fa-trash" style={{ marginRight: '8px' }}></i>Delete
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminJobList;
